function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M13.48315,2 L2.51697195,2 C2.32343609,1.99964399 2.14611971,2.10505325 2.05770538,2.27292285 C1.96807157,2.4430529 1.98380324,2.64792282 2.09831501,2.80330034 L6.1158608,8.32467523 C6.11720223,8.32657878 6.11866564,8.32836337 6.12000711,8.33026692 C6.26598216,8.52252579 6.34500625,8.75547313 6.34537211,8.99472594 L6.34537211,13.4962723 C6.34451845,13.629521 6.39817678,13.7576539 6.49439595,13.8522367 C6.59073703,13.9467005 6.72171216,14 6.85829701,14 C6.92768699,14 6.99646722,13.9864372 7.0606133,13.9603823 L9.31816574,13.1206774 C9.52036011,13.0603586 9.65462789,12.8741673 9.65462789,12.6500239 L9.65462789,8.99472594 C9.65499375,8.75547313 9.73401784,8.52252579 9.87987095,8.33026692 C9.88121239,8.32836337 9.88267583,8.32657878 9.88401726,8.32467523 L13.901685,2.80318137 C14.0161968,2.64792282 14.0319284,2.44317187 13.9422946,2.27304182 C13.8540023,2.10505325 13.6765639,1.99964399 13.48315,2 Z"
});
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7f562d0848e5de2db3e9d7b15d41c492.svg";
export { ForwardRef as ReactComponent };